import { createApp, h, provide } from "vue";
import { createPinia } from "pinia";
import Notifications from "notiwind";

import "@/assets/app.css";

import App from "./App.vue";
import router from "./router";
import AppLayout from "@/layouts/components/AppLayout.vue";
import { createMetaManager } from "vue-meta";
import filters from "@/common/filters";
import { DefaultApolloClient } from "@vue/apollo-composable";
import { BASE_URL } from "@/common/constants";
import { createApolloClient } from "@/common/apollo/client";
import { createWallet, WALLET_CONTEXT } from "@/common/composables/useWallet";
import { createOrders, ORDERS_CONTEXT } from "@/common/composables/useOrders";

const app = createApp({
  setup() {
    provide(DefaultApolloClient, createApolloClient(BASE_URL));
    provide(WALLET_CONTEXT, createWallet());
    provide(ORDERS_CONTEXT, createOrders());
  },
  render: () => h(App),
});

app.use(createPinia());
app.use(createMetaManager());
app.use(router);
app.component("AppLayout", AppLayout);
app.use(Notifications);
app.config.globalProperties.$filters = filters;

app.mount("#app");
